module.exports = __webpack_public_path__ + "img/fig9.16.3bb2d652.png";